import VScrollLock from 'v-scroll-lock';

export default (Vue) => {
    Vue.use(VScrollLock);
};
